import axios from 'axios';
import defaultLogo from '../assets/Empower-logo.png';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { environment } from '../env/environment';
import { useTenant } from '../context/TenantContext';

axios.defaults.withCredentials = true;

const VerifyOtp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { tenant } = useTenant();
  const email = location.state?.email;

  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);

  // Get the logo to display
  const rawLogo = tenant?.signinLogoUrl || tenant?.logoUrl || defaultLogo;
  const isDefaultLogo = !tenant?.signinLogoUrl && !tenant?.logoUrl;
  const logoToDisplay = rawLogo && !rawLogo.startsWith('data:') ? rawLogo + (rawLogo.includes('?') ? '&' : '?') + '_v=' + Date.now() : rawLogo;

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');
    
    try {
      const response = await axios.post(`${environment.baseUrl}/api/auth/verify-otp`, { email, otp });
      setMessage(response.data.message);
      setError('');

      // ✅ Get resetToken from response and pass it to reset password page
      const resetToken = response.data.resetToken;
      
      // Navigate to reset password page with resetToken (no email needed)
      navigate('/reset-password', { state: { resetToken } });

    } catch (err) {
      setError(err.response?.data?.message || 'Invalid OTP.');
      setMessage('');
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setResendLoading(true);
    setError('');
    setMessage('');
    
    try {
      const response = await axios.post(`${environment.baseUrl}/api/auth/resend-otp`, { email });
      setMessage('OTP resent successfully!');
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to resend OTP.');
      setMessage('');
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="signin-container">
      <div className='bg-image-container'>
        <img
          src={logoToDisplay}
          alt={tenant?.brandName || 'Logo'}
          className={isDefaultLogo ? 'default-logo' : ''}
        />
      </div>
      <div className='form-container'>
        <form className="form" onSubmit={handleOtpSubmit}>
          <button
            type="button"
            className="back-btn forgot-btn"
            onClick={() => navigate('/')}
          >
            <ArrowBackIosNewIcon className='arrow-icon' /> Back to Login
          </button>

          <div className='signin-heading'>
            <h1>Verify code</h1>
            <p>An authentication code has been sent to your email.</p>
          </div>

          <div className="otp-container">
            <p>Enter OTP <span style={{color:'red'}}>*</span></p>
            <div className='inputForm'>
              <input
                className="input"
                type="text"
                value={otp} 
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter 6-digit OTP"
                required
              />
            </div>
            <p>
              Didn't receive a code? 
              <span 
                onClick={resendLoading ? null : handleResendOtp}
                style={{ 
                  color: resendLoading ? '#ccc' : '#007bff', 
                  cursor: resendLoading ? 'not-allowed' : 'pointer', 
                  textDecoration: 'underline', 
                  marginLeft: '5px' 
                }}
              >
                {resendLoading ? 'Resending...' : 'Resend'}
              </span>
            </p>
            {message && <p className="success-message">{message}</p>}
            {error && <p className="error-message">{error}</p>}
          </div>

          <button 
            type="submit" 
            className="button-submit"
            disabled={loading || !otp.trim()}
            style={{
              opacity: loading || !otp.trim() ? 0.6 : 1,
              cursor: loading || !otp.trim() ? 'not-allowed' : 'pointer'
            }}
          >
            {loading ? 'Verifying...' : 'Verify'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyOtp;